import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { PACKAGES_TO_REMEDIATE } from "~/components/Remediation/constants";
import React from "react";
import { PackageToRemediateType } from "~/components/Remediation/types";
import { RemediationRadioSkeleton } from "../RemediationFilter/RemediationRadioSkeleton";

export type Props = {
  packagesType: PackageToRemediateType;
  handlePackagesToIncludeClick: (
    _e: React.ChangeEvent<HTMLInputElement>,
    value: string,
  ) => void;
  fixAllPackagesLabel: string;
  isLoading: boolean;
};

export const PackagesToInclude = ({
  packagesType,
  handlePackagesToIncludeClick,
  fixAllPackagesLabel,
  isLoading,
}: Props) => {
  return isLoading ? (
    <RemediationRadioSkeleton />
  ) : (
    <>
      <Typography textTransform="uppercase" fontWeight={700} mb={2}>
        Define packages to include
      </Typography>
      <RadioGroup
        data-testid="ecosystem-packages-type"
        aria-labelledby="packages-to-include"
        sx={{
          "& .MuiFormControlLabel-label": { fontWeight: 700 },
        }}
        value={packagesType}
        onChange={handlePackagesToIncludeClick}
      >
        <FormControlLabel
          key="all"
          control={<Radio />}
          label={fixAllPackagesLabel}
          value={PACKAGES_TO_REMEDIATE.ALL}
        />

        <FormControlLabel
          key="individual"
          control={<Radio />}
          label="Fix individual packages"
          value={PACKAGES_TO_REMEDIATE.INDIVIDUAL}
        />
      </RadioGroup>
    </>
  );
};
